var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDolyamesmalllogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34356_196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.125 8.46027H20.9427V19.5269H23.125V8.46027Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4358 9.07952H16.2534V20.1459H18.4358V9.07952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7466 9.77085H11.5642V20.8394H13.7466V9.77085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.05734 10.4699H6.875L6.87501 21.5397H9.05735L9.05734 10.4699Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34356_196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.25,
    height: 16.25,
    fill: "white",
    transform: "translate(6.875 6.875)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDolyamesmalllogo);
export default __webpack_public_path__ + "static/media/Dolyame small logo.e5a07f9bf77644948b9eb066b8c763c1.svg";
export { ForwardRef as ReactComponent };